<template>
	<div>
		<div class="row">
			<div class="col-sm-6">
				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.certificateNo') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.certificate_no">
					</div>
				</div>
				
				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.qualification') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.qualification">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('misc.number') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.number">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.welding_process') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.welding_process">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.welding_type') }}</label>
					</div>
					<div class="col-sm-7" v-if="defaultProjectSettings">
						<select v-model="value.welding_type" class="form-control">
							<option v-for="(setting, index) in defaultProjectSettings.weld_type" :key="index" :value="index">
								{{ setting }}
							</option>
						</select>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.group_filler_material') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.group_filler_material">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.range_of_filler_material') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.range_of_filler_material">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label for="wps">{{ $t('table.wps') }}</label>
					</div>
					<div class="col-sm-7">
						<multiselect v-model="value.selectedWps"
							:options="currentWps"
							:multiple="false"
							:clear-on-select="true"
							:hide-selected="false"
							:loading="isWpsLoading"
							:preserve-search="true"
							placeholder=""
							label="wps" track-by="id"
							:selectLabel="''"
							@search-change="onWpsSearch"
							@input="updateWps"
						>
							<template slot="clear" slot-scope="props">
								<div 
									v-if="value.selectedWps != null" 
									class="multiselect__clear" 
									@mousedown.prevent.stop="clearSelectedWps"
								>
								</div>
							</template>
							<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
							<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						</multiselect>
					</div>
				</div>
			</div>

			<div class="col-sm-6">
				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.material') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.material">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.dia') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.dia">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.thickness') }}</label>
					</div>
					<div class="col-sm-7">
						<input type="text" maxlength="50" class="form-control" v-model="value.thickness">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.remarks') }}</label>
					</div>
					<div class="col-sm-7">
						<textarea rows="6" maxlength="5000" class="form-control" v-model="value.remark"></textarea>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('misc.expire_date') }}</label>
					</div>
					<div class="col-sm-7">
						<flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="value.expire_at"></flat-pickr>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-sm-5">
						<label>{{ $t('table.expire_remark') }}</label>
					</div>
					<div class="col-sm-7">
						<textarea rows="6" maxlength="5000" class="form-control" v-model="value.expire_remark"></textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';

export default {
	name: 'CertificateModal',
	components: {
		flatPickr,
		Multiselect
	},
	props: {
		value: {
			type: Object,
			default: {
				certificate_no: null,
				wps_id: null,
				qualification: null,
				number: null,
				welding_process: null,
				welding_type: null,
				group_filler_material: null,
				range_of_filler_material: null,
				material: null,
				dia: null,
				thickness: null,
				remark: null,
				expire_at: null,
				expire_remark: null,
				selectedWps: null,
			}
		}
	},
	data() {
		return {
			isWpsLoading: false,
			currentWps: []
		}
	},
	mounted () {
	},
	computed: {
		defaultProjectSettings: {
			get: function() {
				let settings = this.$store.getters.getDefaultProjectSettings;
				return settings;             
			}
		}
	},
	watch: {
		defaultProjectSettings: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
			}
		}
	},
	methods: {
		updateFields(){
			this.$emit('updateWps', this.value.wps_id);
		},
		onWpsSearch(search) {
			if (search == '') {
                this.currentWps = [];
                
                return false;
            }

			this.isWpsLoading = true;
			this.searchWps(search, this);
		},
		searchWps: _.debounce((search, vm) => {
			let data = http.route('wps?filters[company_id]=' + vm.$store.state.userSelectedRole.company_id + '&get_all=1&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentWps = response.data;
				}
				vm.isWpsLoading = false;
			});
		}, 500),
		updateWps(wps) {
			this.value.wps_id = (wps != null) ? wps.id : null;
		},
		clearSelectedWps () {
			this.value.selectedWps = null;
			this.value.wps_id      = null;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/CertificateModal.vue